
import { toArray, compact } from 'vessel/utils'

export default {
  props: {
    phone: {
      type: [Array, String],
      default: null
    },
    limit: {
      type: [Number, String],
      default: Infinity
    },
    icon: {
      type: [Boolean, String],
      default: false
    },
    label: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    value() {
      return this.phone || this.$contact.whatsapp
    },
    href() {
      const phone = String(this.value).replace(/\s+|\+/g, '')
      return `https://wa.me/${phone}`
    },
    phones() {
      const phones = compact(toArray(this.value))
      return phones.slice(0, this.limit)
    },
    single() {
      return this.phones.length === 1
    }
  },
  methods: {
    url(number) {
      const phone = String(number).replace(/\s+|\+/g, '')
      return `viber://chat?number=%2B${phone}`
    },
    showComma(index) {
      return index == 0 && this.phones.length > 1
    },
    onClick() {
      this.$tracker.trackEvent('phone_call', {
        category: 'contact',
        label: 'whatsapp'
      })
    }
  }
}
